import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/avatar-with-laptop.png'
import _imports_1 from '@/assets/images/4dots.png'


const _hoisted_1 = {
  class: "card border-0 rounded-3 bg-white",
  style: {"padding":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "bg-success-90 p-25 rounded-3 mb-10 daily-limit-form-dark-mode" }, [
      _createElementVNode("div", { class: "d-flex justify-content-between align-items-start" }, [
        _createElementVNode("div", null, [
          _createElementVNode("span", { class: "d-block" }, "Daily Limit"),
          _createElementVNode("h3", { class: "mb-0 fs-20 mt-6" }, [
            _createTextVNode(" $5,000 "),
            _createElementVNode("sub", { class: "fs-14 fw-normal bottom-0 text-body" }, " /$2250 ")
          ])
        ]),
        _createElementVNode("span", { class: "d-inline-block bg-danger-70 border-danger-80 border px-2 rounded-pill text-danger-80 fs-12 fw-medium" }, " -45.9% ")
      ]),
      _createElementVNode("div", { class: "progress-responsive mt-14" }, [
        _createElementVNode("div", {
          class: "progress rounded-pill",
          style: {"height":"10px","background-color":"#b2ff97"},
          role: "progressbar",
          "aria-label": "Example with label",
          "aria-valuenow": "85",
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }, [
          _createElementVNode("div", {
            class: "progress-bar rounded-pill",
            style: {"width":"85%","height":"10px","background-color":"#37d80a"}
          })
        ])
      ])
    ], -1),
    _createStaticVNode("<div class=\"bg-success rounded-3 mb-0 position-relative z-1\" style=\"padding:18px 25px;\"><div class=\"d-flex align-items-center\" style=\"gap:10px;\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_0 + "\" alt=\"avatar-with-laptop\"></div><div class=\"flex-grow-1\"><span class=\"d-block text-white\">Get a Platinum Card</span><span class=\"text-white mt-6 d-block\"> For <span class=\"fw-bold fs-20\">Free</span></span></div></div><img src=\"" + _imports_1 + "\" class=\"position-absolute bottom-0 end-0\" alt=\"4dots\"></div>", 1)
  ]))]))
}